import { LOCAL_STORAGE_TUNNEL_DATA_KEY } from "../../../core/service/BusinessLogicService"
import { PackServiceContext } from "../../../digital-journey/ServicePage/context/PackServiceContext"
import { verifyPromotionCode } from "../../../service/PromotionService"
import { useContext, useEffect } from "react"
import { useQuery } from "react-query"
import { useLocalStorage } from "react-use"

function useVerifyPromotionCode(supplierId, values, handleSubmit) {
  const [localTunnelData] = useLocalStorage(LOCAL_STORAGE_TUNNEL_DATA_KEY)
  const { verifyiedPromotionCode, selectedPack, validatePromoCode, inValidatePromoCode } =
    useContext(PackServiceContext)

  const verifyPromotionPayload = {
    supplierId: supplierId,
    categoryEvollisId: values?.products[0]?.category?.value,
    price: values?.products[0]?.price,
    duration: selectedPack ? selectedPack?.rentDTO?.duration : null
  }

  const {
    data: isPromoCodeValid,
    isloading: isVerifyingPromoCode,
    refetch
  } = useQuery({
    enabled: !!verifyiedPromotionCode,
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: () => verifyPromotionCode(localTunnelData, verifyiedPromotionCode?.name, verifyPromotionPayload),
    queryKey: ["query-verify-promotion-code", verifyiedPromotionCode?.name, verifyPromotionPayload?.duration],
    onSuccess: (data) => {
      if (data === "VALID") validatePromoCode(verifyiedPromotionCode)
      if (data === "INVALID") inValidatePromoCode(verifyiedPromotionCode)
    },
    onError: () => {}
  })

  useEffect(() => {
    if (verifyiedPromotionCode?.valid && selectedPack) {
      handleSubmit(values)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyiedPromotionCode])

  return { isPromoCodeValid, isVerifyingPromoCode, refetch }
}

export default useVerifyPromotionCode
